export enum ERROR_CODE {
  GENERIC = 'GENERIC',
  INCORRECT_BALANCE = 'INCORRECT_BALANCE',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
}
